import { Component, h } from 'preact'

import { fetchDataForForeignCalculator } from 'services/settings'
import { getDomainsFromAPI, Domains } from 'services/domains-api'

import MainCalculatorFormView from './components/calculator-form'

export interface CalculatorAppState {
  settings: {
    symbolsSorted: string[]
    currenciesNotSupported: string[]
    payoutOwner: string[]
  }
  domains: Domains
}

export default class CalculatorApp extends Component<{}, CalculatorAppState> {
  public constructor(props) {
    super(props)
    this.state = {
      settings: {
        symbolsSorted: [],
        currenciesNotSupported: [],
        payoutOwner: [],
      },
      domains: {},
    }
  }

  public async componentDidMount(): Promise<void> {
    try {
      const domains = await getDomainsFromAPI()
      const settings = await fetchDataForForeignCalculator()

      this.setState({
        settings: {
          symbolsSorted: settings.currency.symbols_sorted,
          currenciesNotSupported: settings['currencies-not-supported'],
          payoutOwner: settings['bank-transfer-countries']['payout_owner'],
        },
        domains,
      })
    } catch (e) {
      //
    }
  }

  public render() {
    return (
      <div id="preact_root">
        <MainCalculatorFormView
          domains={this.state.domains}
          currencies={this.currencies}
          payoutOwner={this.state.settings.payoutOwner}
        />
      </div>
    )
  }

  public removeNotSupportedCurrencies = (currenciesList: string[]): string[] => {
    const { currenciesNotSupported } = this.state.settings
    return currenciesList.filter((currency) => !currenciesNotSupported.includes(currency))
  }

  get currencies(): string[] {
    const { symbolsSorted } = this.state.settings
    return this.removeNotSupportedCurrencies(symbolsSorted)
  }
}
